import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import _ from 'lodash';

import { settlementCurrency as settlementCurrencySelector } from 'session/reducers';
import { actions as errorActions } from 'error';
import BackButton from 'common/components/BackButton';
import Layout from 'common/containers/Layout';
import { api } from 'app/services';
import NewOffRamp from '../components/NewOffRamp';

const newOffRampId = (response) =>
  _.chain(response.success)
    .values()
    .map((offRamp) => offRamp.id)
    .value()[0];

const NewOffRampPage = ({ apiError, settlementCurrency }) => {
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [redirectPath, setRedirectPath] = useState();

  const goBack = () => history.push('/off-ramps');

  const onSubmit = async (values) => {
    setSubmitting(true);

    const { response, error } = await api.createOffRampBill(
      values.amount,
      values.description
    );

    if (error) {
      setSubmitting(false);
      setNetworkError(error);
      apiError(error);
      return;
    }

    const offRampId = newOffRampId(response);
    if (offRampId) {
      setRedirectPath(`/off-ramps/${offRampId}`);
      return;
    }

    setRedirectPath('/off-ramps');
  };

  if (redirectPath) {
    return (
      <Redirect
        to={{
          pathname: redirectPath,
        }}
      />
    );
  }

  return (
    <Layout
      heading="New off ramp"
      sideAction={<BackButton onGoBack={goBack} />}
    >
      <NewOffRamp
        onSubmit={onSubmit}
        settlementCurrency={settlementCurrency}
        submitting={submitting}
        errorMessage={networkError}
      />
    </Layout>
  );
};

NewOffRampPage.propTypes = {
  apiError: PropTypes.func,
  settlementCurrency: PropTypes.string.isRequired,
};

export default connect(
  (state) => ({
    settlementCurrency: settlementCurrencySelector(state),
  }),
  {
    apiError: errorActions.apiError,
  }
)(NewOffRampPage);
